<template>
  <div class="convention-hall page">
    <van-nav-bar
        class="nav-bar"
        :title="$t('预约大厅')"
    />
    <div class="convention-item">
      <div class="left">
        <van-sidebar v-model="activeKey" @change="onChange">
          <van-sidebar-item :title="$t('全部')"/>
          <van-sidebar-item v-for="(v,key) in lotteryitem" :key="key" :title="v.name"/>
        </van-sidebar>
      </div>
      <div class="right">
        <van-pull-refresh v-model="isLoading" :border="false" class="list-wrapper" @refresh="onRefresh">
          <van-grid :column-num="2">
            <van-grid-item v-for="(v,key) in gameitem" :key="key" @click="toLottery(v.key,v.id)">
              <van-image :src="v.ico" class="game_item_img">
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
              <span>{{ v.name }}</span>
              <span>{{ v.desc }}</span>
            </van-grid-item>
          </van-grid>
          <!-- 广告轮播 -->
          <div v-if="$route.path === '/Game' && shouldShowCarousel" class="carouselAds">
            <swiper :options="bannerSwiperOption" class="carouselAds_swiper" v-if="carouselAds && carouselAds.length > 0">
              <swiper-slide v-for="(v,key) in carouselAds" :key="key">
                <div class="swiper-lazy-container">
                  <img 
                    :data-src="v.url" 
                    class="carouselAds_img swiper-lazy" 
                  />
                  <!-- @click="openLink(v.url)" -->
                  <van-loading v-if="!v.url" type="circular" size="24px" />
                </div>
              </swiper-slide>
            </swiper>
            <div class="carouselAds_swiper loadingBox" v-else>
              <van-loading type="circular" size="24px" />
            </div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from 'vant';

export default {
  data() {
    return {
      gameitem: [{}, {}, {}, {}],
      lotteryitem: [{}, {}, {}, {}],
      isLoading: false,
      activeKey: 0,
      // 轮播配置
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        // loop: true,  // 启用循环模式
        autoplay: {
          delay: 3500,            // 3.5秒切换一次
          disableOnInteraction: false, // 用户操作后继续自动播放
          pauseOnMouseEnter: true // 鼠标悬停时暂停
        },
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true,
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
      },
      // 暂时写死广告列表
      carouselAds: [
        // { img: '/img/option-bg/fb.jpg',url: 'https://www.google.com.hk/' },
        // { img: '/img/option-bg/ig.jpg',url: 'https://www.google.com.hk/' },
        // { img: '/img/option-bg/pb.jpg',url: 'https://www.google.com.hk/' },
        // { img: '/img/option-bg/tk.jpg',url: 'https://www.google.com.hk/' },
      ],
    };
  },
  onActivated() {
    console.log('12');
    this.getGameItem();//获取首页游戏列表
    this.getLotteryItem();
  },
  methods: {
    //广告调用链接
    openLink(url) {
      window.open(url, '_blank');
    },
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("刷新成功"));
        this.isLoading = false;
      }, 500);
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/Lottery?key=' + key + "&id=" + id})
      }
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
      })
    },
    getCarouselList() {
      this.$http({
        method: 'get',
        data: {type: 2},
        url: 'lottery_carousel'
      }).then(res => {
        if (res.code === 200) {
          this.carouselAds = res.data;
          console.log("=>(index.vue:555) res.data", res.data);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    onChange(index) {
      this.$http({
        method: 'get',
        data: {class: index},
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
      })
    },
    getLotteryItem() {
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res => {
        this.lotteryitem = res.data;
      })
    }
  },
  computed: {
    shouldShowCarousel() {
      // 当 carouselAds 是原生数组时不展示轮播（按需求）
      if (Array.isArray(this.carouselAds)) return false;
      return this.carouselAds && this.carouselAds.length > 0;
    }
  },
  created() {
    this.getGameItem();//获取首页游戏列表
    this.getLotteryItem();
    this.getCarouselList();//获取轮播广告列表
  }
};
</script>

<style lang='less' scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.nav-bar {
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  height: 100px;

}

.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.van-sidebar {
  width: 180px;
}

.van-sidebar-item--select::before {
  left: 10px;
  height: 44%;
  background-color: #7e5678;
  border-radius: 5px;
  width: 10px;
}

.van-sidebar-item--select {
  color: #7e5678;
  font-size: 35px;
  text-align: center;
}

.van-sidebar-item {
  font-size: 35px;
  text-align: center;
  padding: 50px;
  background-color: #ffffff;
}

.van-sidebar-item--select, .van-sidebar-item--select:active {
  background-color: #f2f2f5;;
}

.convention-item {
  display: flex;
  align-items: center;
  height: calc(100% - 15px);
}

.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: #f2f2f5;
}

.convention-item .left {
  height: 100%;
  background-color: #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.convention-item .right {
  height: 100%;
  flex: 1;
  background-color: #f2f2f5;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.convention-item .right .list-wrapper {
  padding: 20px 20px;
  min-height: 800px;
}

.convention-item .right .list-wrapper .game_item_img {
  width: 200px;
  height: 200px;
}

.convention-item .right .list-wrapper span {
  margin-top: 10px;
  font-size: 30px;
  color: #000;
}

.convention-item .right .list-wrapper span:last-child {
  margin-top: 10px;
  font-size: 24px;
  color: #000;
}

.van-grid-item {
  padding: 10px;

}

::v-deep .van-grid-item__content--center {
  border-radius: 15px;
}

::v-deep .van-image__img {
  border-radius: 40px;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

.carouselAds {
  width: 100%;
  margin-top: 20px;
  padding: 0 1vw;
  height: 60vh; 
}

.carouselAds_swiper {
  height: 100% !important;
  height: auto;
  width: 100%;
  
  .swiper-slide {
    border-radius: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 620px;
    // height: 300px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }
}
.swiper-lazy-container {
    height: 100% !important;
    width: 100%;
  }
.loadingBox {
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carouselAds_img {
  border-radius: 0;
  width: 100%;
  height: 100%;
  // object-fit: cover; 
  display: block;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  .van-sidebar {
    width: 103px; /* 180px * 0.5733 ≈ 103px */
  }

  .van-sidebar-item--select::before {
    left: 6px; /* 10px * 0.5733 ≈ 6px */
    height: 44%;
    width: 6px; /* 10px * 0.5733 ≈ 6px */
    border-radius: 3px; /* 5px * 0.5733 ≈ 3px */
  }

  .van-sidebar-item--select {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .van-sidebar-item {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
    padding: 29px; /* 50px * 0.5733 ≈ 29px */
  }

  .carouselAds {
    // max-height: 150px;
    padding: 0 10px;
    margin-top: 10px;
    .swiper-slide{
      width: 300px;
      // height: 150px;
    }
  }

  .convention-item {
    height: calc(100% - 9px); /* 15px * 0.5733 ≈ 9px */
  }

  .convention-item .right .list-wrapper {
    padding: 11px; /* 20px * 0.5733 ≈ 11px */
    min-height: 458px; /* 800px * 0.5733 ≈ 458px */
  }

  .convention-item .right .list-wrapper .game_item_img {
    width: 115px; /* 200px * 0.5733 ≈ 115px */
    height: 115px; /* 200px * 0.5733 ≈ 115px */
  }

  .convention-item .right .list-wrapper span {
    margin-top: 6px; /* 10px * 0.5733 ≈ 6px */
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .convention-item .right .list-wrapper span:last-child {
    margin-top: 6px; /* 10px * 0.5733 ≈ 6px */
    font-size: 14px; /* 24px * 0.5733 ≈ 14px */
  }

  .van-grid-item {
    padding: 6px; /* 10px * 0.5733 ≈ 6px */
  }

  ::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  ::v-deep .van-grid-item__content--center {
    border-radius: 9px; /* 15px * 0.5733 ≈ 9px */
  }

  ::v-deep .van-image__img {
    border-radius: 23px; /* 40px * 0.5733 ≈ 23px */
  }
}

</style>
